/* eslint-disable react-hooks/exhaustive-deps */
// https://github.com/a-axton/css-properties-values/blob/master/css-properties-values.json
 
import { useEffect } from 'react';
import TextareaAutosize from "react-textarea-autosize";
import Properties from "src/assets/data/css-properties.json";
import { __, camelToKebabCase } from 'src/libs/utilities';
import { useSyncState } from 'src/modules/pe-basic-module/hooks/useSyncState';
import IScalarForm, { VerticalType } from '../interface/IScalarForm';
import Scalar from './Scalar';

const CSSProperties = (props: IScalarForm) : JSX.Element => {
    return <Scalar 
        { ...props } 
        vertical={VerticalType.VERTICAL}
        title={undefined}
        notClear
        enabledForm={<CSSPropertiesEnabled {...props} />}
        desabledForm={<CSSPropertiesDisabled {...props} />}
    />
} 
export default CSSProperties 
 
const CSSPropertiesEnabled = ( props: IScalarForm ): JSX.Element => { 
    const css                   = useSyncState<any>( props.value || {} )
    const str                   = useSyncState<string>( "" )


    const getValue = ( key: string ) : [string, string] => {
        const _key     = camelToKebabCase( key )
        let value      = css.get()[ key ]
        const isLength = !!(Properties.find( (css: any) => css.property === _key )?.values?.find(val => val === "length"))?.length
        if( isLength && typeof value === "number") {
            value       = `${value}px`
        }
        return [ _key, value ]
    }
    const getCSS = () : string => {
        return css.get()
            ?
            Object.keys(css.get()).map(key => {
                const val = getValue( key )
                return `${ val[0] }: ${val[1]};`
            }).join(`\n`)
            :
            " "
    }
    
    const updateCSS = () => {
        try { 
            const obj = str.get()
                .split("\n")
                .map( o => {
                    return o.replace( ";", "" ).split( ":" )
                })
                .reduce(( obj: any, item: string[], index: number ) => {  
                    console.log(obj, item)
                    if( item.length > 1 && !!item[0] ) {
                        obj[item[0]] = item[1]?.trim() || ""; 
                    }
                    return obj; 
                }, {})  
            console.log( obj )
            if(props.onChange) {
                props.onChange( obj, props.field, "")
            }       
        }
        catch( error: any)  {
            
            console.log(error)
            
            // showToast({
            //     message: <Shortcode content={__("Some error in CSS code. See more: ") + "<a href='https://www.w3.org/Style/CSS/all-properties.en.html>docs</a>"} />,
            //     intent: Intent.DANGER
            // })
        }
    }
    const onStr = (evt: any) => {           
        str.set( evt.target.value)   
        console.log( str.get() ) 
         
    }
    useEffect(() => {
        css.set( props.value || {} )
        str.set( getCSS() )
    }, [props.value])

    return <div className="w-100 ml-3 p-0">
            <TextareaAutosize 
                name="code" 
                className="p-3 m-1 w-100 monospace-code " 
                placeholder={__("Start write css code")} 
                onBlur={updateCSS} 
                onChange={ onStr } 
                value={ str.get() }
            />
    </div> 
} 
 
const CSSPropertiesDisabled = ( props: IScalarForm ): JSX.Element | false => {
    return props.value 
        ?     
        <div className="p-3">
            {
                Object.keys(props.value).map(key => {
                    return <div key={key}>
                        {key}: {props.value[key]}
                    </div>
                })
            }
        </div>
        :
        <></>
} 

 